export default "__VITE_ASSET__ab2897ea__"